import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
var LearningCampRequsetComponent = (function () {
    function LearningCampRequsetComponent(route, apiService, el, router) {
        this.route = route;
        this.apiService = apiService;
        this.el = el;
        this.router = router;
        this.selectedTag = "";
        this.placeholder = '';
        this.data = {};
        this.isIcon = false;
        this.isShowToast = false;
        this.destext = "";
        this.isShowPlaceholder = true; //是否显示placeholder
    }
    LearningCampRequsetComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.data.relationId = queryParams['relationId'];
            _this.constituteId = queryParams['constituteId'];
            _this.tabNum = queryParams['tabNum'];
            _this.type = queryParams['type'];
            _this.comment = queryParams['comment'];
            _this.learningPathId = queryParams['learningPathId'];
            _this.courseId = queryParams['courseId'];
            _this.isLastDay = !!queryParams['isLastDay'];
            _this.isFirstDay = !!queryParams['firstDay'];
            _this.projectId = queryParams['projectId'];
            _this.courseLearningPathMetaId = queryParams['courseLearningPathMetaId'];
            _this.workSource = queryParams['workSource'];
        });
    };
    LearningCampRequsetComponent.prototype.ngAfterViewInit = function () {
        this.textarea = this.el.nativeElement.querySelector('textarea');
        if (this.comment) {
            this.textarea.value = this.comment;
        }
    };
    LearningCampRequsetComponent.prototype.back = function () {
        if (this.type === 'comment') {
            if (this.isFirstDay) {
                this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': this.constituteId, 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, learningPathId: this.learningPathId, courseId: this.courseId, firstDay: 1 } });
            }
            else if (this.isLastDay) {
                this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': this.constituteId, 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, learningPathId: this.learningPathId, courseId: this.courseId, isLastDay: 1 } });
            }
            else {
                if (this.workSource == 'homework') {
                    if (this.projectId) {
                        this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': this.constituteId, 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, projectId: this.projectId } });
                    }
                    else if (this.courseLearningPathMetaId) {
                        this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': this.constituteId, 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, courseLearningPathMetaId: this.courseLearningPathMetaId } });
                    }
                }
                else {
                    this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': this.constituteId, 'tabNum': this.tabNum, relationId: this.data.relationId, comment: this.textarea.value, back: 1, learningPathId: this.learningPathId, courseId: this.courseId } });
                }
            }
        }
    };
    //发送
    LearningCampRequsetComponent.prototype.send = function () {
        var _this = this;
        if (!localStorage.getItem("debuonceFlag")) {
            localStorage.setItem("debuonceFlag", "1");
            setTimeout(function () {
                localStorage.removeItem("debuonceFlag");
            }, 4000);
            if (this.type === 'comment') {
                //评论 输入不能为空 可以输入空格
                if (this.textarea.value.length > 0) {
                    //掉接口.then
                    this.data.type = 'comment';
                    this.data.context = this.textarea.value;
                    this.isShowToast = false;
                    this.askQuestion(this.data).then(function () {
                        _this.textarea.value = "";
                        if (_this.isFirstDay) {
                            _this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': _this.constituteId, 'tabNum': _this.tabNum, learningPathId: _this.learningPathId, courseId: _this.courseId, relationId: _this.data.relationId, commentFlag: 1, firstDay: 1 } });
                        }
                        else if (_this.isLastDay) {
                            _this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': _this.constituteId, 'tabNum': _this.tabNum, learningPathId: _this.learningPathId, courseId: _this.courseId, relationId: _this.data.relationId, commentFlag: 1, isLastDay: 1 } });
                        }
                        else {
                            if (_this.workSource == 'homework') {
                                if (_this.projectId) {
                                    _this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': _this.constituteId, 'tabNum': _this.tabNum, relationId: _this.data.relationId, comment: _this.textarea.value, back: 1, projectId: _this.projectId } });
                                }
                                else if (_this.courseLearningPathMetaId) {
                                    _this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': _this.constituteId, 'tabNum': _this.tabNum, relationId: _this.data.relationId, comment: _this.textarea.value, back: 1, courseLearningPathMetaId: _this.courseLearningPathMetaId } });
                                }
                            }
                            else {
                                _this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': _this.constituteId, 'tabNum': _this.tabNum, learningPathId: _this.learningPathId, courseId: _this.courseId, relationId: _this.data.relationId, commentFlag: 1 } });
                            }
                        }
                    }).catch(function (err) {
                        if (err['error']['code'] === 101) {
                            _this.isShowToast = true;
                            _this.toastType = 2;
                            _this.destext = err['error']['msg'];
                            setTimeout(function () {
                                _this.isShowToast = false;
                            }, 1500);
                        }
                    });
                }
                else {
                    this.isShowToast = true;
                    this.destext = '字数要大于0哦~';
                    if (this.isShowToast) {
                        setTimeout(function () {
                            _this.isShowToast = false;
                        }, 2000);
                    }
                }
            }
        }
    };
    LearningCampRequsetComponent.prototype.ngOnDestroy = function () {
        if (localStorage.getItem("debuonceFlag")) {
            localStorage.removeItem("debuonceFlag");
        }
    };
    LearningCampRequsetComponent.prototype.textareaFocus = function () {
        this.isShowPlaceholder = false;
    };
    //textarea失去焦点触发事件
    LearningCampRequsetComponent.prototype.textareaBlur = function () {
        this.isShowPlaceholder = this.textarea.value === "" ? true : false;
    };
    //隐藏Placeholder
    LearningCampRequsetComponent.prototype.closePlaceholder = function () {
        this.isShowPlaceholder = false;
        this.textarea.focus();
    };
    //追问 评论
    LearningCampRequsetComponent.prototype.askQuestion = function (data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/camp/applicationPractice/saveOperationLog',
            'data': data
        }).toPromise();
    };
    return LearningCampRequsetComponent;
}());
export { LearningCampRequsetComponent };



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-request/learning-camp-request.component.ts.pre-build-optimizer.js